module.exports = __webpack_public_path__ + "img/296089.a6b1b87f.svg";